import o from"styled-components";const t=o.div`
	padding: 12px 14px;
	border-radius: ${({borderRadius:o})=>`${o}px`};
	background-color: ${({theme:o})=>o.bg.duoCoverCard};
	height: 270px;
	box-sizing: border-box;
	position: relative;
	overflow: hidden;
`,i=o.div`
	display: flex;
	align-items: start;
	gap: 8px;
	margin-bottom: 4px;
`,e=o.h1`
	margin: 0;
	color: ${({theme:o})=>"dark"===o.name?"#fff":"#121212"};
	font-size: 18px;
	font-weight: 500;
	cursor: ${({isEditable:o=!1})=>o?"text":"default"};
`,r=o.p`
	margin: 0;
	color: #acacac;
	font-size: 14px;
	line-height: 18px;
	white-space: pre-wrap;
	cursor: ${({isEditable:o=!1})=>o?"text":"default"};
`,a=o.span`
	padding: 5px 10px;
	font-size: 12px;
	color: ${({color:o})=>o};
	background: ${({background:o})=>o};
	cursor: ${({isEditable:o=!1})=>o?"text":"default"};
	border-radius: 9999px;
	width: fit-content;
	position: absolute;
	max-width: 80%;
	bottom: 16px;
	left: 16px;
	z-index: 15;
`,d=o.div`
	width: 143px;
	height: 164px;
	background-size: cover;
	position: absolute;
`,n=o(d)`
	transform: rotate(15.3deg);
	z-index: 10;
	border-radius: 10px;
	bottom: -25px;
	right: 100px;
	background-image: url(${({image:o})=>o});
	background-position: ${({position:o})=>o?`${o.x}% ${o.y}%`:"center"};
`,p=o(d)`
	transform: rotate(-8.8deg);
	z-index: 5;
	border-radius: 10px;
	bottom: 0;
	right: 5px;
	background-image: url(${({image:o})=>o});
	background-position: ${({position:o})=>o?`${o.x}% ${o.y}%`:"center"};
`;export{t as CardContainer,i as CardHeader,e as CardHeading,a as CardLabel,r as CardParagraph,d as Image,p as ImageBottom,n as ImageTop};
